var _circle, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#FE572A",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.8367 28.664C63.8367 27.5134 62.8808 26.5807 61.7016 26.5807H25.4052C24.2261 26.5807 23.2702 27.5134 23.2702 28.664V61.9972C23.2702 63.1478 24.2261 64.0805 25.4052 64.0805H61.7016C62.8808 64.0805 63.8367 63.1478 63.8367 61.9972V28.664ZM68.1069 61.9972C68.1069 65.4489 65.2391 68.2471 61.7016 68.2471H25.4052C21.8677 68.2471 19 65.4489 19 61.9972V28.664C19 25.2123 21.8677 22.4141 25.4052 22.4141H61.7016C65.2391 22.4141 68.1069 25.2123 68.1069 28.664V61.9972Z",
    fill: "#FE572A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9695 32.8359V37.0026H21.1328V32.8359H65.9695Z",
    fill: "#FE572A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51.0469,
    y: 19,
    width: 5,
    height: 11,
    rx: 1,
    fill: "#FE572A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.0469,
    y: 19,
    width: 5,
    height: 11,
    rx: 1,
    fill: "#FE572A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9531,
    y: 41.1641,
    width: 6.40524,
    height: 6.24997,
    fill: "#FE572A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9531,
    y: 51.5859,
    width: 6.40524,
    height: 6.24997,
    fill: "#FE572A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 46.7578,
    y: 41.1641,
    width: 6.40524,
    height: 6.24997,
    fill: "#FE572A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 46.7578,
    y: 51.5859,
    width: 6.40524,
    height: 6.24997,
    fill: "#FE572A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.37bb4ac7272ffc8afc5e1512cb531348.svg";
export { ForwardRef as ReactComponent };